/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>

namespace DealerwareWebServices {
    "use strict";

    export interface IDealerwareSearchAliases {

        // properties
        // -------------------------------------------
        aliasData: any,

        // methods
        // --------------------------------------------
        getAlias        ( aliasedItemsToCheck?: string[] ) : string;
        getAliasedItems ( groupState: string )             : string[];
    }


    export interface IDealerwareSolrSearchArgs {
        // properties
        // -------------------------------------------
        searchArgs      :   any;
        searchText      :   string;
        locationId      :   number;
        sortBy          :   string;
        sortDirection   :   string;
        active          :   boolean;
        live            :   boolean;
        live_type       :   string;
        unsettled       :   boolean;
        include_inactive:   boolean;

        // methods
        // --------------------------------------------
        clear()         :   void;
    }


    export interface IDealerwareSolrSearchResults {
        // properties
        subject             :   string;
        results             :   any;
        recordTotal         :   number;
        pageTotal           :   number;
        currentPage         :   number;
        hasNextPage         :   boolean;
        hasPreviousPage     :   boolean;

        //methods
        getNextPage()       :   ng.IPromise<{}>;
        getPreviousPage()   :   ng.IPromise<{}>;
        clear()             :   void;
        isValid()           :   boolean;
    }


    export interface IDealerwareSolrSearch {
        searchResults   :   IDealerwareSolrSearchResults;
        searchArgs      :   IDealerwareSolrSearchArgs;
        locationId?     :   number;

        search(searchArgs? : IDealerwareSolrSearchArgs) : ng.IPromise<{}>;
        autoCompleteSearch(searchArgs? : IDealerwareSolrSearchArgs) : ng.IPromise<{}>;
        clearResults() : void;
    }


    export interface IDealerwareCollectionSolrSearch extends IDealerwareSolrSearch {
        searchFilters : IDealerwareSolrSearchSmartFilters;
        objectCollection : any;
        autoCompleteSearch(searchArgs? : IDealerwareSolrSearchArgs) : ng.IPromise<{}>;
    }


    export interface IDealerwareSolrSearchCustomerCollection extends IDealerwareCollectionSolrSearch {}


    export interface IDealerwareSolrSearchEmployeeCollection extends IDealerwareCollectionSolrSearch {}


    export interface IDealerwareSolrSearchContractCollection extends IDealerwareCollectionSolrSearch {}


    export interface IDealerwareSolrSearchVehicleCollection extends IDealerwareCollectionSolrSearch {
        autoCompleteSearchWithoutFilters(searchArgs?: IDealerwareSolrSearchArgs) : ng.IPromise<{}>;
    }


    export interface IDealerwareSolrSearchSmartFilter {
        name : string;
        searchProperty : string;
        filters: string[];
        searchDisplay() : string;
    }


    export interface IDealerwareSolrSearchSmartFilters {
        filters : IDealerwareSolrSearchSmartFilter[];

        add(filter : IDealerwareSolrSearchSmartFilter) : void;
        search(filterName : string) : IDealerwareSolrSearchSmartFilter[];
    }
}